import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { InputLabel as MuiInputLabel } from '@material-ui/core';
export var InputLabel = styled(MuiInputLabel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  margin-bottom: 2px;\n"], ["\n  font-size: ", ";\n  margin-bottom: 2px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.caption.fontSize;
});
var templateObject_1;
